import { useEffect, useState, useCallback } from "react";
import SiteHeader from "@/components/site/SiteHeader";
import SiteFooter from "@/components/site/SiteFooter";
import HookPanel from "@/components/v5/HookPanel";
import StoryPanel from "@/components/v5/StoryPanel";
import ShopPanel from "@/components/v5/ShopPanel";
import LetterPanel from "@/components/v5/LetterPanel";
import ToolsPanel from "@/components/v5/ToolsPanel";
import ConnectPanel from "@/components/v5/ConnectPanel";
import ShopCategoryDialog from "@/components/v5/ShopCategoryDialog";

const HEADER_OFFSET = 64;

export default function Landing() {
  const [shopCat, setShopCat] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-in");
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -8% 0px" }
    );
    document.querySelectorAll(".panel").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const goTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(y, 0), behavior: "smooth" });
  }, []);

  return (
    <div className="emmy" data-testid="landing-page">
      <SiteHeader onNav={goTo} />

      <main>
        <HookPanel onCta={() => goTo("letter")} />
        <StoryPanel />
        <LetterPanel />
        <ShopPanel onShop={setShopCat} />
        <ConnectPanel />
        <ToolsPanel />
        <SiteFooter onNav={goTo} />
      </main>

      <ShopCategoryDialog cat={shopCat} onClose={() => setShopCat(null)} />
    </div>
  );
}
